import { Locale } from "@redotech/cockroachdb-codegen/tables/common/locale";
import { FlowType } from "@redotech/redo-return-core-common/return-flow-enums";
import {
  FLOW_ELEMENT_TRANSLATABLE_FIELDS,
  TRANSLATION_SOURCES,
} from "@redotech/redo-return-core-common/return-flow/flow-element-translation";
import * as z from "zod";

export const FLOW_ELEMENT_TRANSLATION_WRITE_LIMIT = 200;

export const FLOW_ELEMENT_TRANSLATION_TEXT_LIMIT = 5000;

const KeySchema = z.object({
  elementId: z.string().max(100),
  field: z.enum(FLOW_ELEMENT_TRANSLATABLE_FIELDS),
  language: z.enum(Locale),
});

/**
 * Upserts and deletes a team's flow element translations. A cleared editor
 * value arrives as a delete, so the portal falls back to Redo's default
 * translation (or the English literal) instead of rendering an empty string.
 * Bounded: one editor panel saves a few fields across at most 13 languages.
 */
export const setFlowElementTranslations = {
  name: "setFlowElementTranslations" as const,
  input: z.object({
    writes: z
      .array(
        KeySchema.extend({
          text: z.string().min(1).max(FLOW_ELEMENT_TRANSLATION_TEXT_LIMIT),
          source: z.enum(TRANSLATION_SOURCES),
          sourceText: z
            .string()
            .max(FLOW_ELEMENT_TRANSLATION_TEXT_LIMIT)
            .optional(),
          flowType: z.enum(FlowType),
        }),
      )
      .max(FLOW_ELEMENT_TRANSLATION_WRITE_LIMIT),
    deletes: z.array(KeySchema).max(FLOW_ELEMENT_TRANSLATION_WRITE_LIMIT),
  }),
  output: z.object({}),
};

type SetFlowElementTranslationsInput = z.infer<
  typeof setFlowElementTranslations.input
>;

export type FlowElementTranslationWrite =
  SetFlowElementTranslationsInput["writes"][number];
export type FlowElementTranslationDelete =
  SetFlowElementTranslationsInput["deletes"][number];
